import SORT_ASCENDING from 'constants/SORT_ASCENDING';
import SORT_DEFAULT from 'constants/SORT_DEFAULT';
import SORT_DESCENDING from 'constants/SORT_DESCENDING';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from './FocusableButton';

export default function SortButton(props) {
  const {
    order,
    ...rest
  } = props || {};
  return (
    <FocusableButton {...ex('SortButton', rest)}>
      {order === SORT_DESCENDING && (
        <svg width={15} height={14} viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_76_1086)">
            <path d="M4.60814 5.01086L7.28564 7.68253L9.96314 5.01086L10.7856 5.83336L7.28564 9.33336L3.78564 5.83336L4.60814 5.01086Z" fill="#9B9B9B" />
          </g>
          <defs>
            <clipPath id="clip0_76_1086">
              <rect width={14} height={14} fill="white" transform="translate(0.285645)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {order === SORT_ASCENDING && (
        <svg width={15} height={14} viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_76_2487)">
            <path d="M4.8225 8.98913L7.5 6.31746L10.1775 8.98913L11 8.16663L7.5 4.66663L4 8.16663L4.8225 8.98913Z" fill="black" />
          </g>
          <defs>
            <clipPath id="clip0_76_2487">
              <rect width={14} height={14} fill="white" transform="translate(0.5)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {order === SORT_DEFAULT && (
        <div>
          -
        </div>
      )}
    </FocusableButton>
  );
}


